module.exports = __webpack_public_path__ + "static/media/ooppah-seal.fa752c9e.png";